/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Action_CancelInputs */

const vi_sl_detail_action_cancel = /** @type {(inputs: Sl_Detail_Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy phiếu`)
};

/**

* @param {Sl_Detail_Action_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_action_cancel = /** @type {((inputs?: Sl_Detail_Action_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Action_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_action_cancel(inputs)
});